import styled from 'styled-components';

export const Colortext = styled.span`
  color: ${({theme}) => theme.palette.secondary.main};
  font-weight: 600;
`